import React from "react";
import BaseComponent from "../baseComponent.js";
import IdentityAccessService from "../../core/services/identityAccessService.js";
import VerifyForgotPassword from "./verifyForgotPassword.jsx";
import Preloader from "../common/preloader.jsx";
import styles from "./forgot-password.scss";

export default class ForgotPassword extends BaseComponent {
  constructor(props, context) {
    super(props);
    this.router = context.router;
    this.state = {
      email: ""
    }
  }

  componentDidMount() {
    $(this.refs.username).focus();
    //material library bug. need to investigate
    setTimeout(() => {
      $(this.refs.username).next().addClass("active");
      $(this.refs.password).next().addClass("active");
    }, 200);
  }

  handleChange(event, field) {
    var state = {};
    state[field] = event.target.value;
    this.setState(state);
    $(this.refs.email).siblings(".custom-error").hide();
  }

  handleKeyUp(event) {
    if (event.keyCode === 13) {
      this.login();
    }
  }

  cancel() {
    this.router.replace("/login");
  }

  validate() {
    let isValid = true;

    if (this.state.email.length === 0) {
      $(this.refs.email).addClass("invalid");
      $($(this.refs.email).siblings(".custom-error")[0]).show();
      isValid = false;
    } else if (!validateEmail(this.state.email)) {
      isValid = false;
      $($(this.refs.email).siblings(".custom-error")[1]).show();
    }

    return isValid;
  }

  submit() {
    if (this.validate()) {
      this.showLoader();
      IdentityAccessService.sendResetPasswordRequest(this.state.email)
        .then(res => {
          this.hideLoader();
          $(this.refs.container).hide();
          this.refs.verifyForgotPassword.show();
        });
    }
  }

  showLoader() {
    $(this.refs.backdrop).show();
    this.refs.preloader.show();
  }

  hideLoader() {
    $(this.refs.backdrop).hide();
    this.refs.preloader.hide();
  }

  render() {
    return (
      <div className={styles.backdrop} style={{zIndex: 2000}}>
        <div className={styles.container} ref="container">
          <div className={["row", styles.content].join(" ")}>
            <div className="col s12">
              <div className={styles.title}>Forgot your password?</div>
              <div className={styles.description}>Enter your email. We'll email instructions on how to reset your
                password.
              </div>
            </div>
            <div className="col s12">
              <div className="input-field col s12">
                <i className="material-icons prefix">mail_outline</i>
                <input id="login_username" type="email" className="validate" ref="email"
                       value={this.state.email} onKeyUp={(e) => this.handleKeyUp(e)}
                       onChange={(e) => this.handleChange(e, "email")}/>
                <label htmlFor="login_username">Email</label>
                <div className="custom-error" style={{marginLeft: "45px"}}>Email address is required.</div>
                <div className="custom-error invalid-email" style={{marginLeft: "45px"}}>Invalid email address.</div>
              </div>
            </div>
          </div>
          <div className={styles.footer}>
            <a className="waves-effect btn-flat cancel-btn" onClick={this.cancel}>Cancel</a>
            <a className={["waves-effect waves-light btn", styles.button].join(" ")} onClick={this.submit}>Submit</a>
          </div>
        </div>
        <VerifyForgotPassword ref="verifyForgotPassword" getUserEmail={this.getUserEmail}/>
        <div className={styles.preloader} ref="backdrop">
          <Preloader ref="preloader"/>
        </div>
      </div>
    )
  }
}

ForgotPassword.contextTypes = {
  router: React.PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/auth/forgotPassword.jsx